// Nombre y tipo que muestra la auditoría para cambios en ítems de un ArrayField.
// Spec: specs/features/ProtocolForms/arrayfield-creator.md (regla 13)

const _uncapitalize = (text) => text.charAt(0).toLowerCase() + text.slice(1);

// Ítem agregado: con componentsType se usa el título del dominio (p. ej. medicalRecords.adverseEvents.title);
// sin componentsType, el nombre genérico de lista.
export const resolveNewArrayItemName = (arrayField, t) =>
    arrayField?.componentsType
        ? t(`medicalRecords.${_uncapitalize(arrayField.componentsType)}.title`)
        : t('protocols.visit.formTemplate.componentsTypes.none');

// Campo modificado dentro de un ítem: sin componentsType se formatea según el tipo del propio campo.
export const resolveArrayItemFieldType = (arrayField, componentField) =>
    arrayField?.componentsType || componentField?._t;
